import { create } from "zustand"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { getNegativeUsageAPI } from "@/apis/apt-api"

export const anomalyStore = create((set) => ({
  negativeUsageMap: {},

  apiGetNegativeUsage: async () => {
    const { sido, kapt_code, ended_at } = aptSearchStore.getState().pickApt
    const result = await getNegativeUsageAPI({
      sido,
      kapt_code,
      ended_at
    })

    set({ negativeUsageMap: result })
  }
}))
